var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticStyle: { "padding-top": "15%" }, attrs: { justify: "center" } },
        [
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("label", { staticClass: "bid-sent-lbl" }, [
              _vm._v("Your bid has been sent!"),
            ]),
          ]),
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("img", { attrs: { src: _vm.ic_tick_green } }),
          ]),
          _c(
            "v-col",
            { staticClass: "ta-c mt-n4", attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "a-few-things-lbl" }, [
                _vm._v("Please check your "),
              ]),
              _c(
                "v-chip",
                {
                  staticClass: "in-progress-chip mx-1",
                  attrs: { color: "#FA93A4", "text-color": "white" },
                },
                [_vm._v("Bids in Progress")]
              ),
              _c("label", { staticClass: "a-few-things-lbl" }, [
                _vm._v(" tab in your dashboard for carrier responses."),
              ]),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "ta-c mt-10", attrs: { cols: "12" } },
            [
              _c("smart-btn", {
                attrs: { label: "Spot Market Dashboard", type: "primary" },
                on: { click: _vm.goToDashboard },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }